// extracted by mini-css-extract-plugin
export var container = "_9b-0";
export var icon = "_9b-1";
export var text = "_9b-2";